module.exports = require("./../../_gen/starling/rendering/BatchToken");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/rendering/BatchToken.js
// module id = 211
// module chunks = 0